export default __webpack_public_path__ + "static/media/home.a9b5f70d.svg";